import { ReactNode } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Stack,
} from '@mui/material'

type Action = {
  label: string
  onClick: () => void
}

type CheckinAlertDialogProps = {
  open: boolean
  title?: string
  text: ReactNode
  noAction?: Action
  yesActions: Action[]
}

const CheckinAlertDialog = ({
  open,
  title,
  text,
  noAction,
  yesActions,
}: CheckinAlertDialogProps) => (
  <Dialog data-cy='checkinAlertDialog' open={open}>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <DialogContentText>{text}</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Stack
        direction={yesActions.length > 1 ? 'column' : 'row'}
        alignItems='flex-end'
      >
        {yesActions.length > 1 ? (
          <>
            {yesActions.map(({ label, onClick }, index) => (
              <Button data-cy={`yesAction-${label}`} key={`${label}-${index}`} onClick={onClick}>
                {label}
              </Button>
            ))}
            {noAction && (
              <Button data-cy={`noAction-${noAction.label}`} onClick={noAction.onClick}>
                {noAction.label}
              </Button>
            )}
          </>
        ) : (
          <>
            {noAction && (
              <Button data-cy={`noAction-${noAction.label}`} onClick={noAction.onClick}>
                {noAction.label}
              </Button>
            )}
            {yesActions.map(({ label, onClick }, index) => (
              <Button data-cy={`yesAction-${label}`} key={`${label}-${index}`} onClick={onClick}>
                {label}
              </Button>
            ))}
          </>
        )}
      </Stack>
    </DialogActions>
  </Dialog>
)

export default CheckinAlertDialog
